'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const react = require('@emotion/react');
const components_patterns_ZapierLogoSymbol_svgs_Styles = require('./Styles.cjs.js');

const SymbolSize20 = () => {
  return react.jsx(
    "svg",
    { css: components_patterns_ZapierLogoSymbol_svgs_Styles.Styles.root, width: "20", height: "20", "data-testid": "ZapierLogoSymbolSmall", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    react.jsx("rect", { width: "20", height: "20", rx: "3", fill: "#FF4F00" })
  );
};

exports.SymbolSize20 = SymbolSize20;
//# sourceMappingURL=SymbolSize20.cjs.js.map
